import { z } from 'zod'

/**
 * Whether a row of an event's link history records a link made or taken off.
 * Mirrors the `GhlLinkAction` enum in the Prisma schema (`check:enums`).
 */
export const GHL_LINK_ACTIONS = ['linked', 'unlinked'] as const

export const ghlLinkActionSchema = z.enum(GHL_LINK_ACTIONS)

export type GhlLinkAction = z.infer<typeof ghlLinkActionSchema>
